import { FC } from 'react';
import {
  amountBasicFieldFormattingProps,
  numericBasicFieldFormattingProps,
} from '@app/shared/components/form-controls/form-field/form-field-patterns';
import { EquityItem } from '../../CapitalStructureItemFormERF2';
import { useLocale } from '@app/core/hooks/useLocale';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { currencyDenominationPair, instrumentOwnersSortFn } from '@app/shared/helpers';
import styles from '../../capital-structure-item-form-2.module.scss';
import FormField from '@app/shared/components/form-controls/form-field/FormField';
import { OwnerType } from '@app/shared/models/contracts/enums/shared-enums';
import { getSharesLabel } from '@app/shared/utils/LabelHelper';

interface CapitalStructureCreateTableProps {
  equityItem: EquityItem;
}

const PARENT_CLASSNAME = 'capital-structure-values-table';

const CapitalStructureCreateTable: FC<CapitalStructureCreateTableProps> = ({ equityItem }) => {
  const { l } = useLocale();
  const project = useAppSelector((state) => state.project.projectDraft);
  const { currency, denomination } = project.details;

  const getOwnersBySequence = equityItem.ownership
    .slice()
    .sort((ownerA, ownerB) => instrumentOwnersSortFn(ownerA.owner, ownerB.owner));

  return (
    <div>
      <table className={styles[`${PARENT_CLASSNAME}`]}>
        <thead>
          <tr>
            <th className={styles[`${PARENT_CLASSNAME}__label-column--owner`]}>{l('_Owners')}</th>
            <th>
              {l('_AmountCurrency', { currency: currencyDenominationPair(currency, denomination) })}
            </th>
            <th>{getSharesLabel(denomination)}</th>
          </tr>
        </thead>
        <tbody>
          {getOwnersBySequence.map((owner, index) => (
            <tr key={owner.owner}>
              <td className={styles[`${PARENT_CLASSNAME}__label-column`]}>
                {OwnerType[owner.owner]}
              </td>
              <td>
                <FormField
                  name={`ownership[${index}].amount`}
                  {...amountBasicFieldFormattingProps}
                  placeholder="0"
                  autoHeight
                />
              </td>
              <td>
                <FormField
                  name={`ownership[${index}].numberOfShares`}
                  {...numericBasicFieldFormattingProps}
                  placeholder="0"
                  autoHeight
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CapitalStructureCreateTable;
